import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import DoNotSellPage from "@/pages/DoNotSellPage";

function App() {
    return (
        <div className="app-shell">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/privacy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms" element={<TermsOfServicePage />} />
                    <Route path="/do-not-sell" element={<DoNotSellPage />} />
                    <Route path="*" element={<LandingPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
        </div>
    );
}

export default App;
